var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFfmap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19 0 0 1.19 328.19 336.99)",
    id: "6IrZnEklhoyNv7Ohr6GyK"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.54 -77.72)",
    id: "deOSB1PkEpEIFrwanRuoI"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-243.46, -172.28)",
    d: "M 243.46 19.224 C 327.934 19.224 396.515 87.806 396.515 172.279 C 396.515 256.752 327.934 325.334 243.46 325.334 C 158.987 325.334 90.406 256.752 90.406 172.279 C 90.406 87.806 158.987 19.224 243.46 19.224 Z M 243.081 95.057 C 285.213 95.057 319.419 129.263 319.419 171.395 C 319.419 213.526 285.213 247.732 243.081 247.732 C 200.949 247.732 166.743 213.526 166.743 171.395 C 166.743 129.263 200.949 95.057 243.081 95.057 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.85 88.73)",
    id: "--i3QFkab6HHo6aiEeUuL"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-244, -338.57)",
    d: "M 94.839 208.97 C 94.839 208.97 210.269 471.314 219.976 476.814 C 226.534 480.531 244.32 479.225 255.166 477.987 C 260.631 477.363 265.424 474.05 267.941 469.157 C 288.318 429.666 380.849 249.405 391.781 210.855 C 404.076 167.5 330.63 246.77 330.63 246.77 L 228.064 275.889 L 152.353 251.623 L 128.087 213.767 L 94.839 208.97 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -130.01 14.44)",
    id: "cGjhGMMLErmq0bz7eIKjQ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-119.99, -264.44)",
    d: "M 106.333 239.589 L 133.644 294.89 L 131.524 233.992 L 106.333 239.589",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfmap);
export default __webpack_public_path__ + "static/media/ffmap.4f9596dec991caab31ea4f780b7df424.svg";
export { ForwardRef as ReactComponent };